
import { defineComponent, nextTick, ref, toRefs, watch } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
// 展示页面需要引入样式才能显示
// <link rel="stylesheet" href="https://unpkg.com/@vueup/vue-quill@beta/dist/vue-quill.snow.prod.css">
// <link rel="stylesheet" href="https://unpkg.com/@vueup/vue-quill@1.0.0-beta.8/dist/vue-quill.snow.prod.css">
import Quill from 'quill'
import ImageUploader from 'quill-image-uploader'
import { Message } from '@arco-design/web-vue'
import { useHttp } from '@/plugins/http'
import { Api } from '@/apis'
import { AliOSS } from '@jsh/helper/utils'

Quill.register('modules/imageUploader', ImageUploader)

export default defineComponent({
  components: { QuillEditor },
  props: {
    modelValue: {
      type: String,
      required: true,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup (props, context) {
    const { emit } = context

    const http = useHttp()
    const { modelValue } = toRefs(props)
    const editor = ref()

    setTimeout(() => {
      editor.value.setHTML(modelValue.value)
    }, 1000)

    const toolbar = [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      ['clean'],
      ['bold', 'italic', 'underline', 'strike'],
      // [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ['image']
    ]
    const imageUploader = {
      upload: (file: File) => {
        return new Promise((resolve, reject) => {
          if (file.size > 1024 * 1024) {
            Message.error('图片过大')
            return resolve('')
          }
          new AliOSS({
            bucket: 'jsh-oss-static',
            cname: false,
            endpoint: 'oss-cn-beijing.aliyuncs.com',
            region: 'cn-beijing'
          })
            .setToken(() => {
              return new Promise((resolve, reject) => {
                http
                  .get<{
                    accessKeyId: string;
                    accessKeySecret: string;
                    securityToken: string;
                  }>(Api.getSTSToken)
                  .then((res) => {
                    if (res.data.success) {
                      resolve({
                        accessKeyId: res.data.data.accessKeyId,
                        accessKeySecret: res.data.data.accessKeySecret,
                        securityToken: res.data.data.securityToken
                      })
                    }
                  })
              })
            })
            .upload({
              file,
              env: 'prod',
              filetype: 'image'
            })
            .then((res) => {
              const url = 'https://jsh-oss-static.jsh.com/' + res.name
              resolve(url)
            })
            .catch((err) => {
              console.error(err)
              reject(err)
            })
        })
      }
    }

    const options = {
      // debug: 'error',
      modules: {
        toolbar,
        imageUploader
      },
      readOnly: false
    }

    function updateContent (content:string) {
      emit('update:modelValue', content)
    }

    return {
      options,
      editor,
      updateContent
    }
  }
})
